import { render, staticRenderFns } from "./TheProductCustomizerVisualizer.vue?vue&type=template&id=4215c05e&"
import script from "./TheProductCustomizerVisualizer.vue?vue&type=script&lang=js&"
export * from "./TheProductCustomizerVisualizer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4215c05e')) {
      api.createRecord('4215c05e', component.options)
    } else {
      api.reload('4215c05e', component.options)
    }
    module.hot.accept("./TheProductCustomizerVisualizer.vue?vue&type=template&id=4215c05e&", function () {
      api.rerender('4215c05e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/customizer/TheProductCustomizerVisualizer.vue"
export default component.exports